import { Component, Input } from "@angular/core";
import { DashboardMenuTabSelectorService } from "../services/dashboardMenuTabSelector.service";

@Component({
    selector: "tab-redirector",
    template: "<ng-content></ng-content>",
    standalone: false
})
export class TabRedirectorComponent {
    @Input() public redirectToTab: number;

    constructor(private dashboardMenuTabSelectorService: DashboardMenuTabSelectorService) {
    }

    public redirect(event: Event): void {
        if (event) event.stopPropagation();
        this.dashboardMenuTabSelectorService.selectedTab = this.redirectToTab;
    }
}